export default {
    token: "",
    setToken(token){
        this.token = token
    },
}